/**
 * The toggle visibility module.
 *
 * @return {void}
 */
export const toggleVisibility = () => {
  // Set the elements
  const $triggers = document.querySelectorAll(".toggle-visibility");

  // Check if any triggers exists
  if ($triggers) {
    $triggers.forEach(($trigger) => {
      // Add a click event listener to the trigger
      $trigger.addEventListener("click", () => {
        // Prevent the default action
        event.preventDefault();

        // Set the elements
        const $currentTrigger = event.currentTarget;
        const $currentTarget = document.querySelector(
          $currentTrigger.dataset.toggleVisibilityTarget
        );

        // Check if the target exists
        if ($currentTarget) {
          // Set the data
          const group = $currentTarget.dataset.toggleVisibilityGroup;

          // Check if the target belongs to a group
          if (group) {
            // Set the elements
            const $targets = document.querySelectorAll(
              `[data-toggle-visibility-group="${group}"]`
            );

            // Check if the targets exist
            if ($targets) {
              // Cycle through all of the targets
              $targets.forEach(($target) => {
                // Set the target classes
                $target.classList.add("hidden");

                // Check if the target is the current target
                if ($target === $currentTarget) {
                  // Set the target classes
                  $target.classList.remove("hidden");
                }
              });
            }
          } else {
            // Set the current target classes
            $currentTarget.classList.toggle("hidden");
          }
        }
      });
    });
  }
};

// Export the module
export default toggleVisibility;
